import * as Sentry from '@sentry/vue';
import { getUserContextForSentry, addUserToSentryScope, } from '@/util/sentry-user';
const SentryAzurePlugin = {
    install(Vue) {
        Vue.config.errorHandler = (err, vm, info) => {
            if (err.message?.includes('MSAL') ||
                err.message?.includes('azure') ||
                info?.includes('azure')) {
                Sentry.withScope((scope) => {
                    scope.setTag('module', 'azure');
                    scope.setTag('vueErrorInfo', info);
                    scope.setTag('errorSource', 'vue-global');
                    scope.setExtra('componentName', vm?.$options.name || 'unknown');
                    scope.setExtra('vueInfo', info);
                    try {
                        const userData = vm?.$store?.state?.user;
                        if (userData) {
                            const userContext = getUserContextForSentry(userData);
                            if (userContext) {
                                addUserToSentryScope(scope, userContext);
                            }
                        }
                    }
                    catch (error) {
                        // Ignore errors
                    }
                    Sentry.captureException(err);
                });
            }
        };
        window.addEventListener('unhandledrejection', (event) => {
            const error = event.reason;
            if (error?.message?.includes('MSAL') ||
                error?.message?.includes('azure')) {
                Sentry.withScope((scope) => {
                    scope.setTag('module', 'azure');
                    scope.setTag('errorSource', 'unhandled-promise');
                    scope.setExtra('promiseRejection', true);
                    scope.setExtra('url', window.location.href);
                    try {
                        const storedUser = localStorage.getItem('objekto');
                        if (storedUser) {
                            const parsed = JSON.parse(storedUser);
                            const userData = parsed?.user;
                            if (userData) {
                                const userContext = getUserContextForSentry(userData);
                                if (userContext) {
                                    addUserToSentryScope(scope, userContext);
                                }
                            }
                        }
                    }
                    catch (error) {
                        // Ignore errors
                    }
                    Sentry.captureException(error);
                });
            }
        });
    },
};
export default SentryAzurePlugin;
